var map = {
	"./components/DuplicationLog.vue": [
		"0bbc"
	],
	"./components/GamePlay.vue": [
		"bac6"
	],
	"./components/TouchFullScreen.vue": [
		"f1cc"
	],
	"./layouts/default.vue": [
		"7b3d",
		"layout-layouts-default-vue"
	],
	"./layouts/result.vue": [
		"9529",
		"layout-layouts-result-vue"
	],
	"./views/Home.vue": [
		"bb51"
	],
	"./views/Result.vue": [
		"eeac",
		"layout-views-Result-vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8b10";
module.exports = webpackAsyncContext;